<template>
  <div class="login" v-if="!authenticated">
    <div id="sherpa_logo" class="w3-center">
      <img src="/static/logo.jpg" class="w3-image">
    </div>
    <transition name="fade" mode="out-in">
      <div v-if="!rememberPassword" id="form-login">
        <div>
          <form @submit.prevent="login">
            <transition name="fade" mode="out-in">
              <div v-if="langOptions" class="w3-section login-languages">
                <label>{{ $ml.get('language') }}</label>
                <multiselect
                  v-model="lang"
                  :options="langOptions"
                  :placeholder="$ml.get('select')"
                  :selectLabel="$ml.get('enterForSelect')"
                  :deselectLabel="$ml.get('enterForDelete')"
                  :custom-label="langName"
                  :allow-empty="false"
                  @input="valueChanged()"
                  @open="openValue"
                  @close="closeValue">
                    <span v-bind:class="{'active':isOpen==true}" class="arrow" slot="caret"><i class="fa fa-angle-down fa-2x"></i></span>
                </multiselect>
              </div>
              <spinner-loading v-else :line-size='2' :size="23" line-fg-color='#5dbecd' />
            </transition>
            <div class="w3-section w3-hide">
              <label class="capitalize">{{ $ml.get('username') }}</label>
              <input class="w3-input Input-Background" type="text" name="username" v-model="username">
            </div>
            <div class="w3-section w3-hide">
              <label class="capitalize">{{ $ml.get('password') }}</label>
              <input class="w3-input Input-Background" type="password" name="password" v-model="password">
            </div>
            <div id="contenidor-submit">
              <button id="submit" type="submit" class="w3-btn">
                <transition name="fade" mode="out-in">
                  <spinner-loading v-if="authStatus === 'loading'" :line-size='2' :size="23" line-fg-color='#5dbecd' />
                  <span v-else class="capitalize">{{ $ml.get('enter') }}</span>
                </transition>
              </button>
              <button id="remember-password" class="w3-btn" @click="openRememberPassword()">
                <span>{{ $ml.get('rememberPassword') }}</span>
              </button>
            </div>
            <div class="login-messages">
              <transition name="fade" mode="out-in">
                <span v-if="!dataFilled" class="formErrors">
                  <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('errorLoginEmpty') }}.
                </span>
                <span v-else-if="authStatus === '400'" class="formErrors">
                  <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error400') }}.
                </span>
                <span v-else-if="authStatus === '401'" class="formErrors">
                  <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error401') }}.
                </span>
                <span v-else-if="authStatus === '412'" class="formErrors" key="error412">
                  <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error412') }}
                </span>
                <span v-else-if="authStatus === 'password-setted'" class="formOk">
                  <i class="sherpa-icon icon-ico_ok"></i> {{ $ml.get('passwordSetted') }}.
                </span>
                <span v-else-if="authStatus && authStatus !== 'success' && authStatus !== 'loading'" class="formErrors">
                  <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error500') }}.
                </span>
              </transition>
            </div>
          </form>
        </div>
      </div>
      <div v-else id="remember-password-container">
        <div>
          <transition name="fade" mode="out-in">
            <div v-if="!rememberOperationId" class="w3-section">
              <i class="sherpa-icon icon-cerrar" @click="closeRememberPassword()"></i>
              <label>{{ $ml.get('rememberUser') }}.</label>
              <input class="w3-input Input-Background" type="text" name="rememberUser" v-model="username">
              <button id="check-remember-user" class="w3-btn" @click="checkRememberPassword()">
                <transition name="fade" mode="out-in">
                  <spinner-loading v-if="authStatus === 'loading'" :line-size='2' :size="23" line-fg-color='#5dbecd' />
                  <span v-else>{{ $ml.get('rememberPassword') }}</span>
                </transition>
              </button>
            </div>
            <div v-else-if="rememberOperationId && rememberCode" class="w3-section remember-code">
              <i class="sherpa-icon icon-cerrar" @click="closeRememberPassword()"></i>
              <input type="text" ref="code1" name="code1" maxlength="1" v-model="code1" v-on:keyup="keyupCode1(code1)" v-on:focus="codeSelect" />
              <input type="text" ref="code2" name="code2" maxlength="1" v-model="code2" v-on:keyup="keyupCode2(code2)" v-on:focus="codeSelect" />
              <input type="text" ref="code3" name="code3" maxlength="1" v-model="code3" v-on:keyup="keyupCode3(code3)" v-on:focus="codeSelect" />
              <input type="text" ref="code4" name="code4" maxlength="1" v-model="code4" v-on:keyup="keyupCode4(code4)" v-on:focus="codeSelect" />
              <input type="text" ref="code5" name="code5" maxlength="1" v-model="code5" v-on:keyup="keyupCode5(code5)" v-on:focus="codeSelect" />
              <input type="text" ref="code6" name="code6" maxlength="1" v-model="code6" v-on:keyup="keyupCode6(code6)" v-on:focus="codeSelect" />
              <button id="check-remember-code" class="w3-btn" @click="checkRememberCode()">
                <transition name="fade" mode="out-in">
                  <spinner-loading v-if="authStatus === 'loading'" :line-size='2' :size="23" line-fg-color='#5dbecd' />
                  <span v-else>{{ $ml.get('checkRememberCode') }}</span>
                </transition>
              </button>
            </div>
            <div v-else-if="rememberOperationId && repeatPassword" class="w3-section repeat-password">
              <i class="sherpa-icon icon-cerrar" @click="closeRememberPassword()"></i>
              <input type="password" :placeholder="$ml.get('newPasword')" ref="new-password-1" name="new-password-1" v-model="newPassword1" v-on:blur="checkNewPassword()" />
              <input type="password" :placeholder="$ml.get('repeatPassword')" ref="new-password-2" name="new-password-2" v-model="newPassword2" v-on:blur="checkNewPassword()" />
              <transition-group name="fade" mode="out-in">
                <span v-if="!newPasswordValidation" class="validation-error" key="incorrectPasswordFormat">
                  <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('incorrectPasswordFormat') }}.
                </span>
                <span v-if="!newPasswordRepeat" class="validation-error" key="incorrectPasswordRepeat">
                  <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('incorrectPasswordRepeat') }}.
                </span>
              </transition-group>
              <button id="check-remember-code" class="w3-btn" @click="checkRememberNewPassword()">
                <transition name="fade" mode="out-in">
                  <spinner-loading v-if="authStatus === 'loading'" :line-size='2' :size="23" line-fg-color='#5dbecd' />
                  <span v-else>{{ $ml.get('checkRememberPassword') }}</span>
                </transition>
              </button>
            </div>
          </transition>
          <div class="login-messages">
            <transition-group name="fade" mode="out-in">
              <span v-if="!dataRememberFilled" class="formErrors" key="errorLoginEmpty">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('errorLoginEmpty') }}.
              </span>
              <span v-else-if="authStatus === '401'" class="formErrors" key="error401Remember">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error401Remember') }}.
              </span>
              <span v-else-if="authStatus === '406'" class="formErrors" key="error406Remember">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error406Remember') }}.
              </span>
              <span v-else-if="authStatus === '408'" class="formErrors" key="error408Remember">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error408Remember') }}.
              </span>
              <span v-else-if="authStatus === '429'" class="formErrors" key="error429Remember">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error429Remember') }}.
              </span>
              <span v-else-if="authStatus === 'repeat-password'" class="formOk" key="repeatNewPassword">
                <i class="sherpa-icon icon-ico_ok"></i> {{ $ml.get('passwordFormat') }}.
              </span>
              <span v-else-if="authStatus === 'remember-code'" class="formOk" key="rememberSuccess">
                <i class="sherpa-icon icon-ico_ok"></i> {{ $ml.get('rememberSuccess') }}.
              </span>
              <span v-else-if="authStatus && authStatus !== 'loading'" class="formErrors" key="error500">
                <i class="sherpa-icon icon-ico_error"></i> pepe {{ $ml.get('error500') }}.
              </span>
              <countdown v-if="rememberOperationId" :end-time="new Date().getTime() + rememberOperationTime" @finish="finishRememberCountdown()" key="countdown">
                <template v-slot:process="timer">
                  <span class="countdown">{{ `(${timer.timeObj.m}:${timer.timeObj.s})` }}</span>
                </template>
              </countdown>
            </transition-group>
          </div>
        </div>
      </div>
    </transition>
    <div id="footer-sidebar" class="w3-center">
      <img src="@/assets/media/logo.png" class="w3-image mountdata-logo">
      <div id="footer-info">
        <p>
          <!--{{ $ml.get('allRightsReserved') }}<br />-->
          <!--{{ $ml.get('registeredTrademark') }}<br />-->
          v{{version}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-definition-utils/src/utils/multiselect' // 'vue-multiselect ^2.1.6' component with TMD modifications
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'
import * as api from '@/utils/api'
import Configuration from '@/configuration'
import vueAwesomeCountdown from 'vue-awesome-countdown'

Vue.use(vueAwesomeCountdown, 'vac') // Component name, `countdown` and `vac` by default

const r = /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=])(?=.{8,}).*$/

export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      dataFilled: true,
      dataRememberFilled: true,
      // variables select idioma
      langOptions: null,
      lang: '',
      isOpen: false,
      rememberPassword: false,
      rememberCode: false,
      repeatPassword: false,
      code1: '',
      code2: '',
      code3: '',
      code4: '',
      code5: '',
      code6: '',
      newPassword1: '',
      newPassword2: '',
      newPasswordValidation: true,
      newPasswordRepeat: true
    }
  },
  components: {
    Multiselect
  },
  methods: {
    langName (language) {
      return this.$ml.get(language)
    },
    valueChanged () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`, { lang: this.lang, ml: this.$ml })
    },
    login () {
      const { username, password } = this
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_REQUEST}`, { username, password })
      /*
      this.dataFilled = true
      if (this.username.trim() !== '' && this.password.trim() !== '') {
        const { username, password } = this
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_REQUEST}`, { username, password })
      } else {
        this.dataFilled = false
      }
      */
    },
    closeValue () {
      this.isOpen = false
    },
    openValue () {
      this.isOpen = true
    },
    checkRememberPassword () {
      this.dataRememberFilled = true
      this.resetCode()
      if (this.username.trim() !== '') {
        const { username } = this
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_REQUEST}`, { username })
      } else {
        this.dataRememberFilled = false
      }
    },
    checkRememberCode () {
      if (this.code1.trim() !== '' && this.code2.trim() !== '' && this.code3.trim() !== '' && this.code4.trim() !== '' && this.code5.trim() !== '' && this.code6.trim() !== '') {
        var code = this.code1.trim() + this.code2.trim() + this.code3.trim() + this.code4.trim() + this.code5.trim() + this.code6.trim()
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_CODE_REQUEST}`, { username: { username: this.username }, code: code, id: this.rememberOperationId })
      }
    },
    openRememberPassword () {
      this.rememberPassword = true
      this.$emit('rememberPassword', this.rememberPassword)
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_RESET}`)
    },
    closeRememberPassword () {
      this.rememberPassword = false
      this.$emit('rememberPassword', this.rememberPassword)
      this.dataRememberFilled = true
      this.resetCode()
      this.repeatPassword = false
      this.rememberCode = false
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_RESET}`)
    },
    keyupCode1 (code) {
      if (code && code.trim() !== '') {
        this.$refs['code2'].focus()
        this.$refs['code2'].select()
      }
    },
    keyupCode2 (code) {
      if (code && code.trim() !== '') {
        this.$refs['code3'].focus()
        this.$refs['code3'].select()
      }
    },
    keyupCode3 (code) {
      if (code && code.trim() !== '') {
        this.$refs['code4'].focus()
        this.$refs['code4'].select()
      }
    },
    keyupCode4 (code) {
      if (code && code.trim() !== '') {
        this.$refs['code5'].focus()
        this.$refs['code5'].select()
      }
    },
    keyupCode5 (code) {
      if (code && code.trim() !== '') {
        this.$refs['code6'].focus()
        this.$refs['code6'].select()
      }
    },
    keyupCode6 (code) {
      if (code && code.trim() !== '') {
        this.$refs['code6'].blur()
      }
    },
    codeSelect (e) {
      e.target.select()
    },
    finishRememberCountdown () {
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, {response: { status: 408 }})
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_OPERATION_ID_RESET}`)
      this.repeatPassword = false
      this.rememberCode = false
      this.resetCode()
    },
    resetCode () {
      this.code1 = ''
      this.code2 = ''
      this.code3 = ''
      this.code4 = ''
      this.code5 = ''
      this.code6 = ''
      this.resetNewPassword()
      this.password = ''
    },
    checkNewPassword () {
      this.newPasswordValidation = r.test(this.newPassword1)
      if (this.newPassword2.trim() !== '') {
        this.newPasswordRepeat = this.newPassword1 === this.newPassword2
      }
    },
    checkRememberNewPassword () {
      if (r.test(this.newPassword1) && r.test(this.newPassword2) && this.newPassword1 === this.newPassword2) {
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_NEW_PASSWORD_REQUEST}`, { username: { username: this.username }, code: btoa(this.newPassword1), id: this.rememberOperationId })
      }
    },
    resetNewPassword () {
      this.newPassword1 = ''
      this.newPassword2 = ''
      this.newPasswordValidation = true
      this.newPasswordRepeat = true
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [
      `${authTypes.AUTH_STATUS}`
    ]),
    authenticated () {
      return this.$store.getters[`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_AUTHENTICATED}`]
    },
    version () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_PACKAGE_VERSION}`]
    },
    rememberOperationId () {
      return this.$store.getters[`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_OPERATION_ID}`]
    },
    rememberOperationTime () {
      return this.$store.getters[`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_OPERATION_TIME}`]
    },
    rememberCodeAttempts () {
      return this.$store.getters[`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_CODE_ATTEMPTS}`]
    }
  },
  beforeMount () {
    this.lang = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`]
    if (!this.$store.getters[`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_AUTHENTICATED}`]) {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, {id: 'login', name: 'Login'})
    }
    this.username = Configuration.value('USER_ADMIN')
    this.password = Configuration.value('PSWD_ADMIN')

    api.call({access: api.ACCESS_LANG, url: '/auth/languages', method: 'POST'})
      .then(resp => {
        this.langOptions = resp

        if (this.langOptions.length === 1) {
          this.lang = this.langOptions[0]
          this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`, { lang: this.lang, ml: this.$ml })

          // first browser enter
          // try to login with the last user token (or external realm login)
          // and pass the first enter path
          const urlParams = new URLSearchParams(window.location.search)
          // callback redirection from realm login
          if (urlParams.get('callback') === '1') {
            this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_REALM_LOGIN}`)
          } else {
            this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_FIRST_CHECK_LOGGED}`, {fullPath: window.location.pathname + window.location.search})
          }
        }
      })
      .catch(err => {
        // open error service dialog
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, {err}, {root: true})
      })
  },
  watch: {
    authenticated (authenticated) {
      if (!authenticated) {
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, {id: 'login', name: 'Login'})
      }
    },
    rememberOperationId (rememberOperationId) {
      if (rememberOperationId) {
        this.$nextTick(() => {
          this.$refs['code1'].focus()
        })
      }
    },
    authStatus (authStatus) {
      if (this.rememberOperationId) {
        if (authStatus === '408' || authStatus === '429') {
          this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_OPERATION_ID_RESET}`)
          this.resetCode()
        } else if (authStatus === 'remember-code') {
          this.rememberCode = true
          this.repeatPassword = false
        } else if (authStatus === 'repeat-password') {
          this.rememberCode = false
          this.repeatPassword = true
        }
      } else if (authStatus === 'password-setted') {
        this.rememberPassword = false
        this.$emit('rememberPassword', this.rememberPassword)
        this.dataRememberFilled = true
        this.resetCode()
        this.dataFilled = true
      }
    },
    rememberCodeAttempts (rememberCodeAttempts) {
      if (rememberCodeAttempts === 3) {
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_OPERATION_ID_RESET}`)
        this.resetCode()
      }
    }
  }
}
</script>

<style lang="scss">
#sherpa_logo {
  margin-top: 78px;

  img {
    width: 200px;
  }
}

#campaign {
  width: 183px;
  height: 45px;
  padding: 13px 19px 14px 22px;
  background-color: #fbbd2d;
  margin: 0 auto;
}

#campaign .Campaign {
  text-transform: uppercase;
  font-family: ''Noto Sans'', sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 8px;
  text-align: center;
  color: #fefefe;
}

#form-login,
#remember-password-container {
  margin-top: 140px;
  display: flex;

  .icon-cerrar {
    color: #fff;
    cursor: pointer;
    transition: all .2s;
    position: absolute;
    right: 0;
    top: -15px;
    font-size: 12px;

    &:hover {
      color: #d42e12;
    }
  }

  > div {
    width: 400px;
    margin: 0 auto;
  }

  label {
    text-transform: capitalize;
    font-family: 'Noto Sans';
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 14px;
    letter-spacing: 0.5px;
    color: #000;
    height: 20px;
  }

  .Input-Background {
    width: 100%;
    height: 40px;
    border-radius: 3px;
    background-color: #ffffff;
    border: solid 1px #e8e8e8;
    font-size: 14px;
  }

  .w3-section {
    margin-top: 18.5px !important;
  }
}

#remember-password-container {
  label {
    text-transform: none;
    color: #fff;
    font-weight: 400;
  }

  .Input-Background {
    margin-top: 5px;
  }

  .w3-section {
    position: relative;
    padding-top: 12px;
  }

  .formErrors,
  .formOk {
    background-color: #fff;
    color: #d42e12;
    padding: 6px 20px;
  }
}

.remember-code {
  input {
    display: inline-block;
    width: 14.233333%;
    margin: 0.666666%;
    height: 55px;
    text-align: center;
    font-size: 22px;
  }
}

.repeat-password {
  input {
    display: inline-block;
    width: 100%;
    height: 45px;
    text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .validation-error {
    width: 100%;
    display: block;
    text-align: center;
    font-size: 13px;
    color: #d42e12;
  }
}

.capitalize {
  text-transform: capitalize;
}

#contenidor-submit {
  margin-top: 20px;
}

#submit,
#check-remember-user,
#check-remember-code {
  width: 100%;
  border-radius: 0;
  background-color: #0a0202;
  padding: 9px 40px 9px;
  min-height: 48px;

  span {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    text-transform: uppercase;
  }

  &:hover {
    span {
      color: #898989 !important;
    }
  }
}

#check-remember-user,
#check-remember-code {
  background-color: #d42e12;
  margin-top: 15px;
  min-height: 40px;

  span {
    font-size: 20px;
  }

  &:hover {
    span {
      color: #0a0202 !important;
    }
  }
}

#footer-sidebar {
  margin-top: 20px;
}

#footer-sidebar img {
  max-width: 177px;
  display: none;
}

#footer-sidebar div#footer-info {
  margin-top: 16px;
  font-family: 'Noto Sans';
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: normal;
  color: #554b5a;
}

.Is-there-a-secret-to {
  margin-top: 159px;
  font-family: 'Noto Sans';
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #ffffff;
  padding: 0 30px;
  display: none;
}

#rest-pantalla .Rectangle-3 {
  max-width: 183px;
  height: 42px;
  border-radius: 8px;
  border: solid 2px #ffffff;
  margin: 0 auto;
}

#rest-pantalla .Rectangle-3 span {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin: 5px;
}

.formErrors,
.formOk {
  vertical-align: middle;
  padding: 11px 20px;
  border-radius: 0;
  color: #fff;
  font-family: 'Noto Sans';
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  float: left;
  width: 100%;
  margin: 5px 0 15px;

  i {
    vertical-align: middle;
    margin-right: 5px;
  }

  .sherpa {
    font-size: 1em;
    position: relative;
    top: 2px;
    margin-right:5px;
  }
}
.formErrors {
  background-color: #d42e12;
}
.formOk {
  color: #fff;
  background-color: #02cd01;
}

#remember-password {
  width: 100%;
  margin-top: 10px;

  span {
    text-decoration: underline;
    font-size: 13px;
    color: #898989;
  }

  &:hover {
    span {
      color: #0a0202;
    }
  }
}
.countdown {
  color: #fff;
  font-size: 13px;
  display: block;
  margin-bottom: 10px;
  text-align: center;
}
</style>

<style>
.multiselect__tags {
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  font-size: 16px;
}
.multiselect__tags .multiselect__single {
  overflow-x: hidden;
}
.multiselect__tag {
  margin-bottom: 0;
}
.multiselect__option--selected {
  background-color: #dddddd;
}
.arrow {
  position: absolute;
  right: 10px;
  top: 5px;
  color: #d42e12;
  transition: transform .2s;
}
.arrow.active {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.choiceWithTask {
  float: left;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue